<div class="card mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">
                    {{ "CampDetails.PricingMatrix" | translate }}
                </h5>
            </div>
        </div>
        <div class="card-text" [formGroup]="form">
            @if (items) {
                <table class="table">
                    <thead>
                        <tr>
                            <th></th>
                            @for (
                                item of items | groupBy: "variantId";
                                track item
                            ) {
                                <th>Variant {{ item.value[0].variantName }}</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of items | groupBy: "tier"; track item) {
                            <tr>
                                <td>
                                    {{
                                        enumTranslation.membershipTier(item.key)
                                    }}
                                </td>
                                @for (price of item.value; track price) {
                                    <td>
                                        {{ price.basePriceTotal | amount }}
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
    </div>
</div>
